import { useGetCasesQuery } from '../redux/services/caseApi';
import { getDefaultCase }  from '../helpers/cases';

const useDefaultCase = ({patientId, providerId}) => {
  const casesQuery = useGetCasesQuery({patient_id: patientId}, {skip: !patientId});
  if (!patientId) return [null, casesQuery];
  const cases = (casesQuery?.data?.data || []);
  const caseData = getDefaultCase(cases, {providerId});
  return [caseData, casesQuery];
};

export default useDefaultCase;